<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>list_alt</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Sucursales</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Nombre"
                    single-line
                    hide-details></v-text-field>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }">
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <td class="text-xs-left">{{ item.empresa }}</td>
                      <td class="text-xs-left">{{ item.nombre }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarDetail">
                  <v-icon>location_city</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate">
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="model.id != null"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate">
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-text-field
                      v-model="model.nombre"
                      label="Nombre"
                      required
                      :disabled="!editMode"
                      v-validate="'required'"
                      data-vv-name="nombre"
                      :error-messages="errors.collect('nombre')"></v-text-field>
                    <v-autocomplete
                      v-model="model.empresaId"
                      :items="empresas"
                      item-text="nombre"
                      item-value="id"
                      label="Empresa"
                      placeholder="Seleccione una empresa"
                      :disabled="!editMode"
                      :menu-props="{ minWidth: '400' }"></v-autocomplete>
                    <v-text-field
                      v-model="model.telefono"
                      label="Teléfono"
                      :disabled="!editMode"></v-text-field>

                    <v-layout
                      title="Punto de Facturación"
                      label="Punto de Facturación">
                      <v-row>
                        <v-col class="body-1"> Punto de Facturación </v-col>
                      </v-row>

                      <v-flex xs4>
                        <v-switch
                          label="Unificado"
                          v-model="model.puntoFacturacion.unificado"
                          :disabled="!editMode"></v-switch>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-model="model.puntoFacturacion.intereses"
                          label="Intereses"
                          :disabled="!editMode"></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-model="model.puntoFacturacion.punitorios"
                          label="Punitorios"
                          :disabled="!editMode"
                          v-if="
                            !model.puntoFacturacion.unificado
                          "></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-model="model.codigoContable"
                          label="Código Cta. Contable"
                          required
                          :disabled="!editMode"></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex xs4>
                        <v-text-field
                          v-model="model.linkWhatsApp"
                          label="Link WhatsApp"
                          required
                          :disabled="!editMode"></v-text-field>
                      </v-flex>
                    </v-layout>

                    <app-domicilio-simple
                      propName="domicilio"
                      :value="model"
                      :editMode="editMode"></app-domicilio-simple>

                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                      <p></p>
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions bottom>
                      <v-speed-dial direction="left">
                        <v-btn
                          slot="activator"
                          color="orange"
                          text
                          small
                          v-show="editMode">
                          <v-icon color="orange">touch_app</v-icon>
                          Mas Acciones
                        </v-btn>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              color="green"
                              @click="copiarDomicilioEmpresa"
                              v-show="editMode">
                              Copiar Domicilio
                            </v-btn>
                          </template>
                          <span>Copiar Domicilio de la Empresa</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              color="green"
                              @click="crearSecuencias"
                              v-show="editMode && model.id > 0">
                              Crear/Verificar Secuencias
                            </v-btn>
                          </template>
                          <span
                            >Verifica que las Secuencias necesarias estén
                            creadas</span
                          >
                        </v-tooltip>
                      </v-speed-dial>

                      <v-spacer></v-spacer>
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        { text: "Empresa", value: "empresa" },
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      model: {
        puntoFacturacion: { unificado: false, intereses: 0, punitorios: 0 },
      }, // registro para ver/editar
      empresas: [],
    };
  },
  async created() {
    this.loadEmpresas();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    inicioActividadesChanged(newDate) {
      this.model.inicioActividades = newDate;
    },
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          "sucursales?nombre=" +
            this.search +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : "false")
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get("sucursales/" + id);
        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = { puntoFacturacion: {} };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem(0);
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      if (isUpdate) {
        try {
          var result = await http.put(
            "sucursales",
            JSON.stringify({ sucursal: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          var result = await http.post(
            "sucursales",
            JSON.stringify({ sucursal: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      if (
        confirm("¿Confirma la eliminación de la sucursal " + item.nombre + "?")
      ) {
        try {
          Vue.$log.debug(item);
          var result = await http.delete("sucursales?id=" + item.id);
          this.alertSuccess("La sucursal ha sido eliminada.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          if (
            error.includes(
              "The DELETE statement conflicted with the REFERENCE constraint"
            )
          ) {
            this.alertError(
              "La sucursal no puede ser eliminada debido a que está asociada a uno o más canales de venta."
            );
          } else {
            this.alertError(error);
          }
        }
      }
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async copiarDomicilioEmpresa() {
      if (this.model.empresaId) {
        try {
          var result = await http.get("empresas/" + this.model.empresaId);

          this.model.domicilio = result.domicilio;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        this.alertWarning(
          "Por favor, seleccione una empresa de la lista y vuelva a intentar."
        );
      }
    },
    async crearSecuencias() {
      try {
        var result = await http.put(
          "sucursales/crearsecuencias",
          JSON.stringify({ sucursal: this.model })
        );
        this.alertSuccess("Se han verificado las Secuencias de la Sucursal.");
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
  },
};
</script>
